export default __webpack_public_path__ + "static/media/FindSchedule.3d3e17bb.png";